const lockedMap: Map<string, boolean> = new Map();

export async function throttle(func: () => unknown, timeout = 250, id?: string) {
    if (!id) {
        const encoded = new TextEncoder().encode(func.toString())
        const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
        id = hashHex;
    }

    const keyIsLocked = lockedMap.get(id);
    if (keyIsLocked) return;

    func();

    setTimeout(() => lockedMap.delete(String(id)), timeout);
    lockedMap.set(id, true);
}